import { render, staticRenderFns } from "./ResellerPackages.vue?vue&type=template&id=49436886&"
import script from "./ResellerPackages.vue?vue&type=script&lang=js&"
export * from "./ResellerPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49436886')) {
      api.createRecord('49436886', component.options)
    } else {
      api.reload('49436886', component.options)
    }
    module.hot.accept("./ResellerPackages.vue?vue&type=template&id=49436886&", function () {
      api.rerender('49436886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Reseller/ResellerPackages.vue"
export default component.exports